import { render } from "./CheckGroups.vue?vue&type=template&id=cebb925c&scoped=true"
import script from "./CheckGroups.vue?vue&type=script&lang=js"
export * from "./CheckGroups.vue?vue&type=script&lang=js"

import "./CheckGroups.vue?vue&type=style&index=0&id=cebb925c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cebb925c"]])

export default __exports__